import { JsonObject, JsonProperty } from 'typescript-json-serializer';

@JsonObject()
class User {
    constructor(
        @JsonProperty({
            required: true,
            beforeDeserialize: (value: number) => value.toString(),
        })
        readonly id: string,
        @JsonProperty({ required: true }) readonly username: string
    ) {}
}

export default User;
